<template>
  <div>
    <div class="invasive-toast" v-show="isOffline">
      <ion-icon :icon="cloudOfflineOutline" class="icon-space" />
      Nessuna connessione internet
      <div>
        <small>L'applicazione potrebbe non funzionare correttamente, i dati potrebbero non essere aggiornati.</small>
      </div>
    </div>
    <div class="invasive-toast" v-show="!isOffline && isOutdated">
      <ion-icon :icon="cloudOfflineOutline" class="icon-space" />
      Impossibile aggiornare le impostazioni
      <div v-if="isOutdated">
        <small>Controlla la tua connessione, quindi chiudi e riapri l'applicazione</small>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
  import { defineComponent } from 'vue';
  import { IonIcon } from '@ionic/vue'
  import { cloudOfflineOutline } from 'ionicons/icons';
  import Storage from '@/models/Storage'
  import { Network } from '@capacitor/network';

  export default defineComponent({
    components: {
      IonIcon
    },
    setup() {
      const last_update = Storage.get("settings-lastupdate")
      let isOutdated = true
      if (last_update){
        const now = new Date()
        const l_date = new Date(last_update)
        const diff = now.getTime() - l_date.getTime()
        isOutdated = diff > (1000 * 60 * 60 * 24 * 7)
      }
      return {
        isOutdated: isOutdated,
        cloudOfflineOutline
      }
    },
    data(){
      return {
        isOffline: false
      }
    },
    async mounted(){
      const status = await Network.getStatus();
      if(status.connected === false){
        this.isOffline = true
      }

      Network.addListener('networkStatusChange', (status) => {
        const was_offline = this.isOffline
        if(status.connected == false){
          this.isOffline = true
        } else {
          this.isOffline = false
          if(was_offline){
            setTimeout(() => {
              window.location.reload()
            }, 300)
          }
        }
      });
    }
  });
</script>


<style>
.invasive-toast{
  position: absolute;
  bottom: 80px;
  left: 20px;
  width: calc(100% - 41px);
  height: auto;
  background-color: rgba(0,0,0,0.8);
  border-radius: 10px;
  color: white;
  z-index: 9999;
  padding: .5em 1em;
}
small{
  line-height: 1.2;
  display: block;
}

@media only screen and (min-width: 900px) {
  .invasive-toast{
    width: 450px;
    left: 50%;
    margin-left: -225px;
  }
}
</style>